import { useState, useCallback } from "react";
import {
  getPresignedUrl,
  uploadToS3Direct,
  confirmAttachmentInDB,
} from "@/shared/services/uploadService";
import { getMimeType } from "@/shared/utils/fileHelpers";

interface UploadState {
  isUploading: boolean;
  progress: number;
  error: string | null;
}

export const useAttachmentUpload = () => {
  const [state, setState] = useState<UploadState>({
    isUploading: false,
    progress: 0,
    error: null,
  });

  const upload = useCallback(
    async (
      file: File,
      relationType: string,
      relationId: string | number,
      metadata?: any,
    ) => {
      setState({ isUploading: true, progress: 0, error: null });

      try {
        const mimeType = getMimeType(file.name);
        const { uploadUrl, s3Key, bucketName } = await getPresignedUrl(
          file.name,
          mimeType,
          relationType,
          relationId,
        );

        await uploadToS3Direct(uploadUrl, file, mimeType, (progress) => {
          setState((prev) => ({ ...prev, progress }));
        });

        const result = await confirmAttachmentInDB({
          relation_type: relationType,
          relation_id: String(relationId),
          s3_key: s3Key,
          s3_bucket: bucketName,
          display_name: file.name,
          file_type: mimeType,
          file_size: file.size,
          ...metadata,
        });

        setState({ isUploading: false, progress: 100, error: null });
        return result;
      } catch (error: any) {
        setState({ isUploading: false, progress: 0, error: error.message });
        throw error;
      }
    },
    [],
  );

  return { ...state, upload };
};
